import { css } from 'react-emotion'

const styles = {
  header: css({
    marginTop: '20px !important',
    color: '#555 !important'
  }),
  container: css({
    paddingBottom: '30px !important'
  }),
  event: css({
    marginTop: '15px !important'
  }),
  summary: css({
    fontWeight: 'normal !important',
    // borderBottom: '1px solid #f5f5f5'
  }),
  commentBox: css({
    border: '1px solid #eee !important',
    borderLeftWidth: '6px !important',
    padding: '10px !important',
    borderRadius: 5
  }),
  timeAgo: css({
    fontSize: '12px'
  }),
  author: css({
    fontWeight: '600'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Activities/ListStyles.js